import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { MORE_POPOVER } from '../../../brands/default/content/components/header';
import { BRAND_APP_AVAILABLE } from '../../../brands/default/features';
import { MORE_POPOVER_LINKS } from '../../../brands/default/links';
import ThemeContext from '../../../providers/ThemeProvider';
import DownloadAppLinks from '../../footer/DownloadAppLinks';
import MorePopoverItem from './MorePopoverItem';

const MorePopover = ({ navigation, selection }) => {
  const links = MORE_POPOVER_LINKS;
  const theme = useContext(ThemeContext);

  return (
    <>
      <ul className="navigation-more__list">
        <h3 className="navigation-more__header">
          {MORE_POPOVER.moreCategories}
        </h3>
        {navigation?.map((item) => {
          return (
            <MorePopoverItem
              active={selection === item.id}
              extLink={item?.externalLink}
              href={item.url}
              key={item.id}
            >
              {item.linkText}
            </MorePopoverItem>
          );
        })}
        {links && links.length > 0 && (
          <h3 className="navigation-more__header">
            {MORE_POPOVER.moreOptions}
          </h3>
        )}
        {links.map((link) => {
          return (
            <MorePopoverItem
              active={selection === link.id}
              extLink={link?.externalLink}
              href={link.href}
              key={link.href}
            >
              {link.text}
            </MorePopoverItem>
          );
        })}
        {BRAND_APP_AVAILABLE && <DownloadAppLinks inline />}
      </ul>

      <style jsx>{`
        .navigation-more__list {
          padding: 10px;
          list-style: none;
          display: block;
          position: absolute;
          top: 100%;
          right: 0;
          width: 300px;
          border: 1px solid #aaaaaa;
          border-radius: 4px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          background-color: white;
          animation-fill-mode: backwards;
          animation: popover-in 0.2s;
        }
        .navigation-more__header {
          color: ${theme.colors.navmoreheader};
          font-size: ${theme.text.navigation.size}px;
          text-transform: ${theme.text.navigation.transform};
          font-weight: bold;
          margin: 10px 0;
        }
        .navigation-more__header:first-child {
          margin-top: 0;
        }
      `}</style>
    </>
  );
};

MorePopover.propTypes = {
  navigation: PropTypes.array,
  selection: PropTypes.number,
};

export default MorePopover;
